import React from 'react'
import { GuaranteeCalculationRowData } from '../../models/types'

function GuaranteeCalculationRow({
  rowItem,
}: {
  rowItem: GuaranteeCalculationRowData
}) {
  return (
    <>
      <div>
        <small className="mb-1">
          {rowItem.commodityCode}
        </small>
        <small className="overflow-ellipsis">
          {rowItem.description}
        </small>
      </div>
      <div>
        {
          rowItem.price ?? '-'
        }
      </div>
      <div>
        {
          rowItem.excise ?? '-'
        }
      </div>
      <div>
        {
          rowItem.dutyRate ?? '-'
        }
      </div>
      <div>
        {
          rowItem.calculatedDuty ?? '-'
        }
      </div>
      <div>
        {
          rowItem.vatRate ?? '-'
        }
      </div>
      <div>
        {
          rowItem.calculatedVat ?? '-'
        }
      </div>
      <div>
        {
          rowItem.calculatedGuaranteedAmount ?? '-'
        }
      </div>
    </>
  )
}

export default GuaranteeCalculationRow
